import data from "../../../../../src/SplitPageLayout/SplitPageLayout.docs.json";
import * as React from 'react';
export default {
  data,
  React
};